import React, { Component } from 'react';
import { Container, Row, Col } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

//Import Pricing Cards
import CardPricing from "../Components/CardPricing";

class PagesPricing extends Component {
    state = {
        pricings: [
            {
                id: 1, title: "Starter", description: "One month subscription plan", icon: "bx-walk", price: "300", duration: "Per month", link: "",
                features: [
                    { title: "Near By Vehicle Location" },
                    { title: "Vehicle Location" },
                    { title: "Available Load" },
                    { title: "Add Business Listing" },
                    { title: "Register Truck" },
                ]
            },
            {
                id: 2, title: "Professional", description: "One year subscription plan", icon: "bx-run", price: "3000", duration: "Per year", link: "",
                features: [
                    { title: "Near By Vehicle Location" },
                    { title: "Vehicle Location" },
                    { title: "Available Load" },
                    { title: "Add Business Listing" },
                    { title: "Register Truck" },
                ]
            },
            
        ]
    }
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                        {/* Render Breadcrumbs */}
                        <Breadcrumbs title="Subscription" breadcrumbItem="Pricing" />

                        <Row className="justify-content-center">
                            <Col lg={6}>
                                <div className="text-center mb-5">
                                    <h4>Choose your Pricing plan</h4>
                                    <p className="text-muted">Choice the plan that best suits your business  </p>
                                </div>
                            </Col>
                        </Row>

                        <Row>

                            {/* Render pricing cards */}
                            {
                                this.state.pricings.map((pricing, key) =>
                                    <CardPricing pricing={pricing} key={"_pricing_" + key} />
                                )
                            }
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default PagesPricing;
